import Base from "components/Creation/components/Base";
// import useSelection from "hooks/useSelection";
import { useSelector } from "react-redux";
import moment from "moment";
import { useEffect, useState } from "react";
import useSelection from "hooks/useSelection";
import useAccount from "hooks/useAccount";
import useStripe from "hooks/useStripe";
import useAPI from "hooks/useAPI";
import { useHistory } from "react-router-dom";
import useBookings from "hooks/useBookings";
import MirumModal from "components/MirumModal";
import BookingSummary from "../Confirm/components/BookingSummary";
import Price from "../Confirm/components/BookingSummary/components/Cost/components/Price";
import PaymentMethod from "./components/PaymentMethod";

const Charge = () => {
  const booking = useSelector((state) => state.booking);
  const stripeHook = useStripe();
  const { API } = useAPI({});
  const history = useHistory();
  const { bookingHasBeenPaid, getCost } = useBookings();
  const { clearBooking } = useSelection({});
  const { getAndSetUser } = useAccount();
  const [showChargeModal, setShowChargeModal] = useState(false);
  const [chargeModalContent, setChargeModalContent] = useState({
    title: "None",
    body: "none",
    positiveBtnBody: "confirm",
    disablePositiveBtn: false,
    hideNegativeBtn: false,
  });
  const [cost, setCost] = useState({
    total: 0,
  });

  useEffect(() => {
    resetChargeModal();
    const params = new URLSearchParams(window.location.search);
    let bookingId = params.get("bookingId");
    if (!booking._id) {
      return console.error("No booking id in state!");
    } else if (booking._id != bookingId) {
      return console.error(
        "bookingId in state does not match bookingId in url",
        booking._id,
        bookingId
      );
    } else {
      setTheCostAndConfirmCharge();
    }
    console.log("Charge page loaded");
    console.log("bookingId", booking._id);
  }, [booking]);

  const setTheCostAndConfirmCharge = async (bookingId) => {
    // await getAndSetCost();
    confirmChargeWithUser(booking._id);
  };

  // const getAndSetCost = async () => {
  //   let cost = await getCost(booking._id);
  //   console.log("confirm cost", cost);
  //   setCost(cost);
  // };

  const resetChargeModal = () => {
    setShowChargeModal(false);
    setChargeModalContent({
      title: "None",
      body: "none",
      positiveBtnBody: "confirm",
      disablePositiveBtn: false,
      hideNegativeBtn: false,
    });
  };

  const confirmChargeWithUser = async () => {
    let user = await getAndSetUser();
    let cost = await getCost(booking._id);

    console.log("chargeUserForBooking -> user", user, booking, cost);
    let confirmMsg = (
      <div>
        We'll be charging your <PaymentMethod bookingId={booking._id} />
        <br />
        &nbsp;for a total of:&nbsp;
        <Price value={cost.total} className="text-black" />
      </div>
    );

    if (cost.total === 0) {
      confirmMsg =
        "this booking is free and will be confirmed. you will not be charged.";
    }

    if (bookingHasBeenPaid(booking) && booking.status === "draft") {
      confirmMsg =
        "your booking has already been paid for and will be confirmed. you will not be charged.";
    } else if (bookingHasBeenPaid(booking) && booking.status === "confirmed") {
      confirmMsg =
        "this booking has already been confirmed and paid for. you won't be charged.";
    }

    // let confirmed = window.confirm(confirmMsg);

    setChargeModalContent({
      ...chargeModalContent,
      title: "please confirm",
      body: confirmMsg,
    });

    setShowChargeModal(true);
  };

  const charge = async () => {
    setChargeModalContent({
      ...chargeModalContent,
      disablePositiveBtn: true,
      positiveBtnBody: "confirming...",
      hideNegativeBtn: true,
    });
    if (
      booking.status === "confirmed" ||
      booking.status === "payment-processing"
    ) {
      history.push("/");
    }

    try {
      let data = await API.get(`/stripe/charge?bookingId=${booking._id}`);
      console.log("data", data);
      if (data.status === "confirmed") {
        // alert("Payment successful!");
        clearBooking();
        history.push("/success?bookingId=" + booking._id);
      } else if (data.status === "already-paid") {
        // alert("Payment already made! - do same as success");
        console.log("payment already made!");
        history.push("/success?bookingId=" + booking._id);
      } else {
        alert("Payment failed - please try again");
        history.push("/confirm");
      }
    } catch (error) {
      console.error("error", error);
    }
  };

  return (
    <Base footerRemove={true} title="Charge">
      {/* <div>
        <h1>Charge</h1>
        <p>Charging your card</p>
      </div> */}
      <BookingSummary booking={booking} selection={booking.selection} />
      <MirumModal
        show={showChargeModal}
        onDidDismiss={() => {
          setShowChargeModal(false);
          history.push("/confirm");
        }}
        positiveBtnBody={chargeModalContent.positiveBtnBody}
        disablePositiveBtn={chargeModalContent.disablePositiveBtn}
        hideNegativeBtn={chargeModalContent.hideNegativeBtn}
        onPositiveBtnClick={async () => {
          await charge();
        }}
      >
        <h1 className="mb-4">{chargeModalContent.title}</h1>
        <p className="pb-4">{chargeModalContent.body}</p>
      </MirumModal>
    </Base>
  );
};

export default Charge;
